export default "__VITE_ASSET__hQuiDMqk__"